import styled from "styled-components";

export const StyledOnboardingContainer = styled.main`
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--mantine-color-gray-0);
  padding: 4rem 1rem 2rem 1rem;

  @media (max-width: 768px) {
    justify-content: flex-start;
    padding-top: 5rem;
    padding-bottom: 6rem;
  }

  .onboarding-card {
    width: 100%;
    max-width: 800px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    padding: 2.5rem;
    position: relative;
    overflow: hidden;

    @media (max-width: 768px) {
      padding: 1.5rem;
    }
  }

  .signature-input input {
    font-family: 'Caveat', 'Brush Script MT', cursive !important;
    font-size: 36px !important;
    color: #000080 !important;
    height: 70px !important;
    line-height: 70px !important;
  }

  .file-upload-container {
    border: 1px dashed var(--mantine-color-primary-4);
    border-radius: 8px;
    padding: 24px;
    text-align: left;
    background-color: #f8f9fa;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background-color: #f1f3f5;
    }

    &.active {
      border-color: var(--mantine-color-primary-6);
      background-color: var(--mantine-color-primary-0);
    }

    .upload-text {
      color: var(--mantine-color-primary-6);
      font-weight: 500;
      margin-bottom: 8px;
    }

    .upload-info {
      color: var(--mantine-color-gray-5);
      margin-bottom: 24px;
    }

    .upload-button {
      border-color: #e9ecef;
      color: black;
      background-color: white;

      .upload-icon {
        color: var(--mantine-color-primary-6);
      }
    }
  }

  .file-preview-container {
    margin-top: 8px;
    padding: 12px;
    background-color: #fff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s ease;

    &:hover {
      border-color: var(--mantine-color-primary-4);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .file-info {
      display: flex;
      align-items: center;
      gap: 12px;
      flex: 1;

      .file-icon {
        color: var(--mantine-color-primary-6);
        flex-shrink: 0;
      }

      .file-details {
        flex: 1;
        min-width: 0;

        .file-name {
          font-size: 14px;
          font-weight: 500;
          color: var(--mantine-color-gray-8);
          margin-bottom: 2px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .file-size {
          font-size: 12px;
          color: var(--mantine-color-gray-5);
        }
      }
    }

    .remove-button {
      flex-shrink: 0;
    }
  }
`;
